import e from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import f from "./iconfont.es5471.js";
const d = {
  display: "block"
}, g = ({ size: a = 16, useVw: l, useRem: n, color: o, withColor: c, removeClassName: t, disableSSR: m, style: r, ...p }) => {
  const x = r ? { ...d, ...r } : d;
  return /* @__PURE__ */ e.createElement(f, { disableSSR: m }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "32px-TRXwakuang", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: l ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (n ? "rem" : "px"), height: l ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (n ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: x, fill: "none", ...p }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: t ? "" : "32px-TRXæç¿"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        className: t ? "" : "normal",
        d: "M16 5.4C10.146 5.4 5.4 10.146 5.4 16c0 5.854 4.746 10.6 10.6 10.6 2.028 0 3.92-.569 5.53-1.555a.9.9 0 0 1 .94 1.535A12.346 12.346 0 0 1 16 28.4C9.152 28.4 3.6 22.848 3.6 16 3.6 9.152 9.152 3.6 16 3.6c6.848 0 12.4 5.552 12.4 12.4a12.363 12.363 0 0 1-1.82 6.47.9.9 0 0 1-1.535-.94A10.556 10.556 0 0 0 26.6 16c0-5.854-4.746-10.6-10.6-10.6Zm-5.797 4.068a.8.8 0 0 1 .77-.249l9.24 2.053a.8.8 0 0 1 .307.141l2.053 1.54a.8.8 0 0 1 .18 1.092l-6.673 9.753a.8.8 0 0 1-1.416-.19l-4.62-13.346a.8.8 0 0 1 .159-.794Zm4.932 10.61.569-3.693-2.968-3.237 2.4 6.93Zm-2.2-8.784 3.457 3.771 1.93-2.574-5.386-1.197Zm6.856 1.573L18.65 14.39l1.975-.898-.833-.625Zm.131 2.482-2.841 1.291-.568 3.692 3.41-4.983Z",
        fillRule: "evenodd",
        fill: c ? i(o, 0, "#262933") : "#262933",
        datafollowfill: c ? i(o, 0, "#262933") : "#262933"
      }
    )
  )));
}, w = g;
export {
  w as default
};
